import React from 'react';
import PropTypes from "prop-types";

class SoldOutBox extends React.Component {
    render() {
        if(this.props.closedForOnlineBooking){
            return(
                <div className="w-full text-grey-darkest bg-grey-lighter p-2 md:p-4">
                    <div>
                        {this.context.t('contact_shore_ex_manager')}
                    </div>
                </div>
            )
        }

        return (
            <div className="w-full text-grey-darkest bg-grey-lighter p-2 md:p-4">
                <div className="uppercase text-2xl mb-2">
                    {this.context.t('sold_out')}
                </div>
                <div>
                    {this.context.t('contact_team')}
                </div>
            </div>
        );
    }
}

SoldOutBox.contextTypes = {
    t: PropTypes.func.isRequired
}

export default SoldOutBox